<template>
  <section class="grid-flex column">
    <div class="flex w100">
      <div class="box">
        <div class="box-title flex middle">
          <div>
            <h3>Páginas Ignoradas</h3>
            <p class="margin-top-s">As urls adicionadas aqui vão ser ignoradas no cálculo da taxa de tracker e no relatório de Páginas.</p>
          </div>
          <div class="flex-1 flex end">
            <div class="button primary" @click="showModalCreate = true">
              Adicionar Nova Página
            </div>
          </div>
        </div>
        <div class="box-content">
          <ul>
            <li v-for="(w, index) in pagesIgnore" :key="index">
              <div class="flex">
                <div class="flex-2">
                  <div>{{ w.url }}</div>
                </div>
                <div class="flex-1 flex end">
                  <div class="button secondary" @click="newPage=w; showModalCreate = true">Editar</div>
                  <div class="button secondary" @click="selectedPageIgnore=w; showModalDelete = true">Deletar</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-if="isEmpty">
            Você não tem páginas ignoradas. Adicione o sua primeira página.
          </div>
        </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
        :show="showModalDelete"
        description="Você tem certeza que deseja deletar esta página ignorada?"
        @cancel="
          showModalDelete = false;
          selectedPageIgnore = null;
        "
        @accept="deletePageIgnore(selectedPageIgnore)"
      ></modal-confirm>

      <modal
        :title="titleModal"
        :show="showModalCreate"
        @close="cleanModal()"
      >
        <div class="content flex column " slot="content">
          <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Url</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newPage.url"
                  autocomplete="off"
                />
              </div>
            </form>
          <div class="flex column w100">
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="createOrUpdatePage()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  createPageIgnore,
  getPagesIgnore,
  deletePageIgnore,
  updatePageIgnore,
} from "@/services/pageIgnore";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "page-ignore",
  components: {
    Modal,
    ModalConfirm,
  },
  data() {
    return {
      showModalDelete: false,
      selectedPageIgnore: null,
      showModalQR: false,
      showModalCreate: false,
      loading: false,
      newPage: {
        name: '',
        rule_name: '',
        event_name: '',
        event_value: '',
        platform: '',
      },
      pagesIgnore: [],
      listPlatform: [
        'FACEBOOKADS',
        'GOOGLEADS',
        'TIKTOKADS',
      ],
      listEvent: [
        'PURCHASE',
        'REGISTER',
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      if (this.newPage.id) {
        return 'Editar Página'
      }

      return 'Criar nova Página'
    },
    isEmpty() {
      return !this.loading && this.pagesIgnore && this.pagesIgnore.length === 0
    }
  },
  mounted() {
    this.getPagesIgnore();
  },
  methods: {
    cleanModal() {
      this.newPage = {
        url: '',
      }
      this.showModalCreate = false
    },
    createOrUpdatePage() {
      if (this.newPage.id) {
        this.updatePageIgnore()
      } else {
        this.createPageIgnore()
      }
    },
    createPageIgnore() {
      let data = {
        url: this.newPage.url,
      };

      if (!data.url) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar o pagina",
        });
      }
      createPageIgnore(data)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Página salva com sucesso",
          });

          this.pagesIgnore.push(result)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar pagina",
          });
        })
        .finally(() => {
          this.showModalCreate = false
        })
    },
    getPagesIgnore() {
      this.loading = true
      getPagesIgnore()
        .then((result) => {
          this.pagesIgnore = result.pages_ignore
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar páginas",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePageIgnore() {
      let params = {
        url: this.newPage.url,
      }
      updatePageIgnore(this.newPage.id, params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalCreate = false
          this.selectedPageIgnore = null
        })
    },
    deletePageIgnore(page) {
      deletePageIgnore(page.id)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Removido com sucesso'
          })
          this.pagesIgnore = this.pagesIgnore.filter(e => e.id != page.id)
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalDelete = false
          this.selectedPageIgnore = null
        })
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 16px;
  padding: 16px 4px;
  .button {
    margin-right: 8px;
  }
}

</style>
